import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as myGlobals from '../app.component';

@Injectable({
  providedIn: 'root'
})
export class InstituteDashboardDetailsService {

  private baseUrl = myGlobals.baseUrl;

  constructor(
    private http:HttpClient
  ) { }

  getInstituteName(){
    return this.http.get(`${this.baseUrl}/getInstituteName`);
  }
  getInstituteDashboardCounts(){
    return this.http.get(`${this.baseUrl}/getInstituteDashboardCounts`);
  }
  updateInstituteRank(){
    return this.http.get(`${this.baseUrl}/updateInstituteRank`);
  }
  averageStudentFacultyGraph(){
    return this.http.get(`${this.baseUrl}/averageStudentFacultyGraph`);
  }
  getDepartmentPerformance(){
    return this.http.get(`${this.baseUrl}/getDepartmentPerformance`);
  }
  getDepartmentWisePerformance(data){
    return this.http.get(`${this.baseUrl}/getDepartmentWisePerformance?department=`+data);
  }
  getInstituteDepartment(){
    return this.http.get(`${this.baseUrl}/getInstituteDashboardDepartment`);
  }
  topSpecialization(data){
    return this.http.get(`${this.baseUrl}/topSpecialization?department=`+data);
  }
  totalParticipation(data){
    return this.http.get(`${this.baseUrl}/totalParticipation?department=`+data);
  }
  recentActivities(){
    return this.http.get(`${this.baseUrl}/recentActivities`);
  }
  globalAverageScore(){
    return this.http.get(`${this.baseUrl}/globalAverageScore`);
  }
  yearWisePerformance(){
    return this.http.get(`${this.baseUrl}/yearWisePerformance`);
  }
  performanceGrowth(){
    return this.http.get(`${this.baseUrl}/performanceGrowth`);
  }

  getStudentAssessmentInstDashCounts(){
    return this.http.get(`${this.baseUrl}/getStudentAssessmentInstDashCounts`);
  }

  getStudentAssessmentDetailsInstDashCounts(){
    return this.http.get(`${this.baseUrl}/getStudentAssessmentDetailsInstDashCounts`);
  }

  getLowDepartmentPerformance(){
    return this.http.get(`${this.baseUrl}/getLowDepartmentPerformance`);
  }
  getDepartmentWiseLowPerformance(data){
    return this.http.get(`${this.baseUrl}/getDepartmentWiseLowPerformance?department=`+data);
  }
  lowSpecialization(data){
    return this.http.get(`${this.baseUrl}/lowSpecialization?department=`+data);
  }
  lowAverageStudentGraph(){
    return this.http.get(`${this.baseUrl}/lowAverageStudentGraph`);
  }
  yearWiseLowPerformance(){
    return this.http.get(`${this.baseUrl}/yearWiseLowPerformance`);
  }
  gapAnalysisCount(){
    return this.http.get(`${this.baseUrl}/gapAnalysisCount`);
  }
  assessmentreportPdfForInstitute(data){
    return this.http.post(`${this.baseUrl}/assessmentreportPdfForInstitute`,data);
  }
  totalLowParticipation(data){
    return this.http.get(`${this.baseUrl}/totalLowParticipation?department=`+data);
  }
}
